module.exports = __webpack_public_path__ + "img/fav.3e842469.png";